import { render, staticRenderFns } from "./SidebarGiftCards.vue?vue&type=template&id=517032e9"
import script from "./SidebarGiftCards.vue?vue&type=script&lang=js"
export * from "./SidebarGiftCards.vue?vue&type=script&lang=js"
import style0 from "./SidebarGiftCards.vue?vue&type=style&index=0&id=517032e9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports